<script>
  export let isRecap = false;
  let showTooltip = false;
  let isPressed = false;
 
  function handleMouseEnter() {
    if (!isMobileDevice()) {
      showTooltip = true;
    }
  }
 
  function handleMouseLeave() {
    if (!isMobileDevice()) {
      showTooltip = false;
    }
  }
 
  function handleTouchStart() {
    if (isMobileDevice()) {
      isPressed = true;
      showTooltip = true;
    }
  }
 
  function handleTouchEnd() {
    if (isMobileDevice()) {
      isPressed = false;
      setTimeout(() => {
        if (!isPressed) {
          showTooltip = false;
        }
      }, 100);
    }
  }
 
  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
 </script>
 


<div class="wrapper-info {isRecap ? 'recap' : ''} ">
  <div class="as-btn-info tooltip-wrapper"
 on:mouseenter={handleMouseEnter}
 on:mouseleave={handleMouseLeave}
 on:touchstart={handleTouchStart}
 on:touchend={handleTouchEnd}
>
  <svg fill="#ffffff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>info</title>
    <path d="M16.247 4.733c0 1.684 1.271 2.825 2.84 2.825s2.842-1.142 2.842-2.825c0-1.685-1.272-2.826-2.842-2.826-1.568 0-2.84 1.141-2.84 2.826zM10.096 14.375c0 0.334-0.061 1.163 0.008 1.662l2.479-2.983c0.513-0.562 1.106-0.955 1.409-0.849s0.47 0.463 0.371 0.795l-4.103 13.59c-0.473 1.588 0.421 3.148 2.599 3.504 3.189 0 5.084-2.158 6.948-4.955 0-0.334 0.111-1.213 0.044-1.713l-2.479 2.982c-0.514 0.562-1.151 0.955-1.455 0.85-0.28-0.098-0.444-0.41-0.389-0.721l4.132-13.653c0.344-1.734-0.59-3.312-2.564-3.514-2.076 0.001-5.136 2.209-7 5.005z"></path>
    </svg>
  </div>



  {#if showTooltip}
  <div class="tooltip">
    <p class="text">Trappes sur mesure fabriquées en France dans notre usine à Amblainville.</p>
    <p class="text">✅ Modèle : Alu Hydro pousser/lâcher - 1 vantail</p>
    <p class="text">✅ Épaisseurs disponibles : 12,5 mm et 25 mm</p>
    <p class="text">✅ Dimensions maximales :</p>
    <p class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Mur : 1200 x 1200 mm</p>
    <p class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Plafond : 900 x 1200 mm</p>
    <p class="text">✅ Délais de livraison express :</p>
    <p class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Paris / IDF : 72h - 3/4 jours ouvrés.</p>
    <p class="text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Reste de la France : 5 jours ouvrés.</p>
  </div>
  {/if}
</div>



<style>

  .text {
    font-size: 16px;
    padding-bottom:5px;
  }

  .tooltip-wrapper {
    position: relative;
    display: inline-block;
    z-index:999999;
  }

  .tooltip {
    position: absolute;
    background-color: #333;
    color: white;
    text-align: left;
    padding: 5px;
    border-radius: 4px;
    z-index: 10;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }

  .tooltip {
      left: 100%;
      top: 0;
      margin-left: 10px;
      width: 700px;
  }
  .wrapper-info.recap .tooltip {
      bottom: 90px;
      top: auto;
      transform: translateX(-250px);
    }

  .wrapper-info {
    display: inline-block;
    vertical-align: bottom;
    margin-left: 30px;
    transform: translateY(-8px);
  }
  .wrapper-info.recap {
    transform: translateY(24px);
  }
  .as-btn-info {
    width:  max-content;
    cursor: pointer;
    box-shadow: 0 0 0 2px #0c4b9b;
    border-radius: 9999px;
    padding: 5px;
    background-color: #0c4b9b;
    transition: all 300ms;

  }
  .as-btn-info:hover {
    box-shadow: 0 0 0 5px #0c4b9b;
  }

  .as-btn-info svg {
    width: 30px;
    height: 30px;
  }

  @media (max-width: 1100px) {
    .tooltip {
      top: 100%;
      width: 500px;
      transform: translateX(-30%);
    }
    .text {
      font-size: 14px; 
    }
    .wrapper-info {
      transform: translateY(-10px);
    }
    .wrapper-info.recap .tooltip {
      bottom: 90px;
      top: auto;
    }
    .wrapper-info.recap {
      transform: translateY(30px);
    }
    .as-btn-info svg {
      width: 20px;
      height: 20px;
    }
  }
  @media (max-width: 700px) {
    .tooltip {
      width: 300px;
      transform: translateX(-100px);
    }
    .wrapper-info.recap .tooltip {
      transform: translateX(-200px);
    }
    .text {
      font-size: 12px; 
    }
    .wrapper-info {
      transform: translateY(0);
    }
  }
</style>
